/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramTransactionsControllerGetRatesQueryResponse } from '../../types/TelegramTransactionsControllerGetRates.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramTransactionsGetRates } from '../../methods/telegramTransactionsGetRates.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramTransactionsGetRatesQueryKey = () => [{ url: '/api/telegram/transactions/rates' }] as const;

export type TelegramTransactionsGetRatesQueryKey = ReturnType<typeof telegramTransactionsGetRatesQueryKey>;

export function telegramTransactionsGetRatesQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramTransactionsGetRatesQueryKey();
  return queryOptions<
    TelegramTransactionsControllerGetRatesQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramTransactionsControllerGetRatesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramTransactionsGetRates(config);
    },
  });
}

/**
 * {@link /api/telegram/transactions/rates}
 */
export function useTelegramTransactionsGetRates<
  TData = TelegramTransactionsControllerGetRatesQueryResponse,
  TQueryData = TelegramTransactionsControllerGetRatesQueryResponse,
  TQueryKey extends QueryKey = TelegramTransactionsGetRatesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramTransactionsControllerGetRatesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramTransactionsGetRatesQueryKey();

  const query = useQuery(
    {
      ...telegramTransactionsGetRatesQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
